import { render, staticRenderFns } from "./ParkingSpaceNewjp.vue?vue&type=template&id=81fcc898&"
import script from "./ParkingSpaceNewjp.vue?vue&type=script&lang=js&"
export * from "./ParkingSpaceNewjp.vue?vue&type=script&lang=js&"
import style0 from "./ParkingSpaceNewjp.vue?vue&type=style&index=0&id=81fcc898&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81fcc898')) {
      api.createRecord('81fcc898', component.options)
    } else {
      api.reload('81fcc898', component.options)
    }
    module.hot.accept("./ParkingSpaceNewjp.vue?vue&type=template&id=81fcc898&", function () {
      api.rerender('81fcc898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/parking-space/ParkingSpaceNewjp.vue"
export default component.exports